import React, { Component } from "react";
import styled from "styled-components";
import CartProduct from "../components/CartProduct/CartProduct";
import { connect } from "react-redux/";
import { mapStateToProps } from "../redux/store";
import { v4 as uuidv4 } from "uuid";
const Container = styled.main`
  margin: 3rem auto;
  max-width: 1200px;
`;
const CartHeader = styled.h1`
  margin-bottom: 3rem;
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
  @media screen and (min-width: 768px) {
    text-align: left;
  }
`;
const Hr = styled.hr`
  border: 1px solid #e5e5e5;
  margin: 1.875rem 0;
`;
const CartDetails = styled.div`
  margin: 1rem auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 300px;

  @media screen and (min-width: 768px) {
    margin: 0;
    margin-top: 1rem;
  }
`;
const CartDetail = styled.div`
  width: 80%;
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0;
  & > * {
    flex: 1;
  }
`;
const InfoText = styled.div`
  font-size: 1.5rem;
  font-weight: 400;
`;
const InfoAmount = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
`;
const Order = styled.button`
  padding: 1rem 0;
  width: 100%;
  margin-top: 1rem;
  background-color: ${({ quantity }) =>
    quantity ? "#5ece7b" : "rgba(94,206,123,0.5)"};
  cursor: ${({ quantity }) => (quantity ? "pointer" : "default")};
  border: none;
  color: white;
  font-size: 14px;
  font-weight: 600;
`;
class CartPage extends Component {
  componentDidMount() {
    document.title = "Cart";
  }
  render() {
    if (this.props.cartState) {
      const totalProductsQuantity = this.props.cartState.reduce(
        (prev, product) => (prev += product.quantity),
        0
      );
      const totalPrice = this.props.cartState.reduce((prev, product) => {
        const productPrice = product.productDetails.prices.find(
          (price) => price.currency.label === this.props.currencyState.label
        );
        return (prev += productPrice.amount * product.quantity);
      }, 0);
      return (
        <Container>
          <CartHeader>CART</CartHeader>
          <Hr />
          {this.props.cartState?.map((product) => (
            <CartProduct key={uuidv4()} product={product} />
          ))}
          <CartDetails>
            <CartDetail>
              <InfoText>Tax 21%:</InfoText>
              <InfoAmount>
                {this.props.currencyState.symbol}
                {(totalPrice * 0.21).toFixed(2)}
              </InfoAmount>
            </CartDetail>
            <CartDetail>
              <InfoText>Quantity:</InfoText>
              <InfoAmount>{totalProductsQuantity}</InfoAmount>
            </CartDetail>
            <CartDetail>
              <InfoText>Total:</InfoText>
              <InfoAmount>
                {this.props.currencyState.symbol}
                {totalPrice.toFixed(2)}
              </InfoAmount>
            </CartDetail>
            <Order
              quantity={totalProductsQuantity}
              onClick={() =>
                totalProductsQuantity > 0 &&
                this.setState({ checkoutToggle: true })
              }
            >
              ORDER
            </Order>
          </CartDetails>
        </Container>
      );
    }
  }
}
export default connect(mapStateToProps)(CartPage);
